var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-logout-btn",on:{"click":_vm.logoutBtn}},[_c('div',{staticClass:"icon"},[_c('IconLogout2')],1),_c('div',{staticClass:"text-md font-medium leading-6 truncate"},[_vm._v(" "+_vm._s(_vm.$t('btnLabel'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }